// @flow

import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { isMobile } from 'react-device-detect'
import { Flip } from 'react-reveal'

import { CartActions } from '../../../containers'
import { HELPER, PRODUCT_HELPER } from '../../../utils'
import { configActions } from '../../../store/actions'
import { useLoadMore } from '../../../hooks'
import { ContentSpinner } from '../../../components'

let itemExist, pageNumber, cart_product

function Products() {
	let dispatch = useDispatch()
	useLoadMore({ catalogProduct: true })
	const { cart, config, inventory } = useSelector((state) => state)

	const { status } = useSelector((state) => state.meta.translation)

	const { cart_items } = cart
	const { catalog_info_loading, catalog_journey_settings, catalog_without_product_journey } = config
	const {
		products,
		productsPerPage,
		visibleProducts,
		productsCurrentPage,
		totalPages,
		selected_category,
		categories,
		loadMore,
	} = inventory // selected_product,
	const [visibleProductsBySort, setVisibleProductsBySort] = useState([])

	const { catalog_cart_items } = catalog_journey_settings

	let cart_itemList = cart_items.items

	useEffect(() => {
		sortFunctionHandler('sort_by_order')
	}, [])

	useEffect(() => {
		if (selected_category?.id === 0 && isMobile) {
			var element = document.getElementsByTagName('body')[0]
			element.classList.add('height_none')
			// dispatch(configActions.SET_CATALOG_VISIBLE_PRODUCT({ products, productsPerPage: allProducts.length, productsCurrentPage:1 }))
		}
		
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [productsPerPage, catalog_info_loading, productsCurrentPage])

	useEffect(() => {
		cart_product = ''
		if (
			!HELPER.isEmpty(catalog_without_product_journey?.set_catalog_without_product) &&
			HELPER.stringToBoolean(catalog_without_product_journey?.set_catalog_without_product)
		) {
			cart_product = catalog_without_product_journey?.catalog_without_product_item
			dispatch(configActions.EMPTY_CATALOG_WITHOUT_PRODUCT_JOURNEY())
		} else if (!HELPER.isEmpty(catalog_cart_items) && !HELPER.isEmpty(catalog_cart_items?.id)) {
			cart_product = catalog_cart_items
		}

		if (!HELPER.isEmpty(cart_product)) {
			// find page number of the product added
			let currentItemIndex = products.findIndex((item) => item.id === cart_product.id)
			for (let index = 1; index <= totalPages; index++) {
				if (currentItemIndex + 1 <= index * productsPerPage) {
					pageNumber = index
					break
				}
			}
			dispatch(
				configActions.UPDATE_CURRENT_PRODUCT_PAGE({
					products,
					productsPerPage: productsPerPage,
					productsCurrentPage: pageNumber,
				})
			)
			// make selected category is same as  product added category
			let categoryId
			const productCategories = cart_product?.category
			if (HELPER.isEmpty(productCategories)) {
				categoryId = 0
			} else {
				const category = productCategories?.find(
					(item) => item.merchant_product_id === cart_product.id
				)
				categoryId = category?.category_id
			}
			if (categoryId !== selected_category?.id) {
				const updateCategory = categories.find((item) => item.category?.id === categoryId)
				// INACTIVE CATEGORY CASE
				if (!HELPER.isEmpty(updateCategory)) {
					dispatch(
						configActions.SET_CATALOG_VISIBLE_PRODUCT(updateCategory, {
							productsPerPage,
							productsCurrentPage: pageNumber,
						})
					)
				}
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [catalog_cart_items, totalPages, catalog_without_product_journey])

	useEffect(() => {
		// why this condition?
		if (selected_category?.id === 0 && isMobile) {
			var element = document.getElementsByTagName('body')[0]
			element.classList.add('height_none')
			// dispatch(configActions.SET_CATALOG_VISIBLE_PRODUCT({ products, productsPerPage: allProducts.length, productsCurrentPage:1 }))
		} else if (!catalog_info_loading) {
			// dispatch(configActions.SET_CATALOG_VISIBLE_PRODUCT({ products, productsPerPage, productsCurrentPage }))
		}
		sortFunctionHandler('sort_by_order')
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selected_category, productsPerPage, catalog_info_loading, productsCurrentPage])

	const sortFunctionHandler = (type) => {
		let sortedProducts = [...visibleProducts] // Create a copy of visibleProducts to avoid mutating the original array
		switch (type) {
			case 'sort_by_order':
				sortedProducts.sort((a, b) => a.sort_order - b.sort_order) // Sort by the order property
				break
			case 'sort_by_name':
				sortedProducts.sort((a, b) => a.name.localeCompare(b.name)) // Sort by the name property using localeCompare for string comparison
				break
			case 'sort_by_low_price':
				sortedProducts.sort((a, b) => a.selected_variant.price - b.selected_variant.price)
				break
			case 'sort_by_high_price':
				sortedProducts.sort((a, b) => b.selected_variant.price - a.selected_variant.price)
				break
			default: // Sort by the name property using localeCompare for string comparison
				sortedProducts.sort((a, b) => a.sort_order - b.sort_order) 
				break
		}

		setVisibleProductsBySort(sortedProducts)
	}

	return status === 1 ? (
		<div className="">
			<div
				className={`productListingWrap pb-1 ${
					cart_items?.count > 0 ? 'productListingSpacing' : ''
				}`}
			>
				<div className="insideProdListingContainer">
					<div
						className={`product-listing  ${selected_category?.id === 0 && isMobile ? 'mb-5' : ''}`}
					>
						<select
							className="dropdownSorter"
							onChange={(x) => sortFunctionHandler(x.target.value)}
						>
							<option value="sort_by_order">Sort by Order</option>
							<option value="sort_by_name">Sort by Name</option>
							<option value="sort_by_low_price">Sort by Low to High</option>
							<option value="sort_by_high_price">Sort by High to Low</option>
						</select>

						<ul>
							{visibleProductsBySort.map((product, i) => {
								cart_itemList = cart_items.items
								itemExist = cart_itemList.findIndex((item) => {
									return (
										item.product.id === product.id &&
										item.product.selected_variant.variant_id === product.selected_variant.variant_id
									)
								})
								return (
									<Flip top opposite key={i}>
										<li className="col-md-2" key={i}>
											<div className="insidePrdBox">
												<div className="prdImgBox">
													{PRODUCT_HELPER.PRODUCT_IMAGE_COMPONENT(product)}
												</div>
												{/* PRODUCT ACTIONS */}
												{itemExist !== -1 && product?.has_variants === 0 ? (
													<CartActions product={product} keyIndex={i} />
												) : (
													''
												)}
												{/* PRODUCT ACTIONS */}
												<div className="prodShotDetailsWrap">
													<div className="prodName">
														<span>{PRODUCT_HELPER.FORMAT_PRODUCT_NAME(product)}</span>
													</div>
													<div className="prodAddNotes">
														{PRODUCT_HELPER.DISPLAY_ADDITIONAL_NOTES(product, false)}
													</div>
													<div className="prodPrice suggestPrice strikeText">
														{PRODUCT_HELPER.FORMAT_PRICE(product)}{' '}
													</div>
													<div className="prodPrice newPrice">
														{PRODUCT_HELPER.FORMAT_DISCOUNTED_PRICE(product)}
													</div>
												</div>
											</div>
										</li>
									</Flip>
								)
							})}
						</ul>
					</div>

					{totalPages > productsCurrentPage &&
						(loadMore ? <ContentSpinner /> : <div id="flyout-left-container"></div>)}
				</div>
			</div>
		</div>
	) : (
		''
	)
}

export default Products
